/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import React from 'react';
import { Button } from '@scuf/common';
import './ConnectionError.scss';
import './Error.scss';
import { IErrorProps } from './IErrorProps';
import descriptors from '../../../locales/en-US/descriptors';
import { useTranslation } from '@scuf/localization';

const ConnectionError = (props: IErrorProps) => {
  const { title, message, onRefresh } = props;
  const d = descriptors.energyManagement;
  const [t] = useTranslation();
  return (
    <React.Fragment>
      <div className="emaas-error-container">
        <div className="emaas-connection-error-container">
          <h1 className="title">{title}</h1>
          <p className="description display-linebreak">{message}</p>
          <div className="btn">
            <Button
              type="secondary"
              content={t(d.REFRESH)}
              onClick={onRefresh}
            />
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ConnectionError;
